var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error,
                    disable: !_vm.manageLiveClasses
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 1024 } },
              [
                _c("q-input", {
                  ref: "description",
                  attrs: {
                    "float-label": _vm.$t("introduction"),
                    rows: "1",
                    "max-height": 100,
                    type: "textarea",
                    error: _vm.$v.description.$error,
                    disable: !_vm.manageLiveClasses
                  },
                  on: { input: _vm.$v.description.$touch },
                  model: {
                    value: _vm.description,
                    callback: function($$v) {
                      _vm.description = $$v
                    },
                    expression: "description"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.getLiveClassPlatformTypes,
                "float-label":
                  _vm.platform_type === "jitsi"
                    ? _vm.$t("stream_type_jitsi_8x8_warning")
                    : _vm.$t("stream_type"),
                chips: "",
                "autofocus-filter": "",
                disable: !_vm.manageLiveClasses
              },
              model: {
                value: _vm.platform_type,
                callback: function($$v) {
                  _vm.platform_type = $$v
                },
                expression: "platform_type"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _vm.platform_type !== "jitsi"
              ? _c("q-input", {
                  ref: "embed",
                  attrs: {
                    "float-label": _vm.$t("transmission_url"),
                    error: _vm.$v.embed.$error,
                    disable: !_vm.manageLiveClasses
                  },
                  on: { input: _vm.$v.embed.$touch },
                  model: {
                    value: _vm.embed,
                    callback: function($$v) {
                      _vm.embed = $$v
                    },
                    expression: "embed"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm.selected_client_params.live_class_use_score
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                !_vm.selected_client_params.live_class_use_static_score &&
                _vm.canSetScore
                  ? _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("score"),
                        type: "number",
                        disable: !_vm.manageLiveClasses
                      },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e(),
                _vm.selected_client_params.live_class_use_static_score &&
                _vm.canSetScore
                  ? _c("q-select", {
                      attrs: {
                        options: _vm.scoresOptions,
                        "float-label": _vm.$t("score"),
                        disable: !_vm.manageLiveClasses
                      },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.isChevrolet
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12" },
              [
                _c(
                  "q-field",
                  { attrs: { helper: _vm.$t("training_code_helper_message") } },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "text",
                        "float-label": _vm.$t("training_code"),
                        disable: !_vm.manageLiveClasses
                      },
                      model: {
                        value: _vm.code,
                        callback: function($$v) {
                          _vm.code = $$v
                        },
                        expression: "code"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.timezones,
                "float-label": _vm.$t("timezone"),
                filter: "",
                disable: !_vm.manageLiveClasses
              },
              on: { input: _vm.changeTimezone },
              model: {
                value: _vm.timezone,
                callback: function($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "q-field",
              {
                attrs: {
                  helper:
                    "" +
                    _vm.$t(
                      "the_time_showed_here_will_be_adjust_for_the_user_timezone"
                    )
                }
              },
              [
                _c("q-datetime", {
                  ref: "date_class",
                  attrs: {
                    type: "datetime",
                    "float-label": _vm.$t("live_class_date"),
                    format: "DD/MM/YYYY HH:mm",
                    error: _vm.$v.date_class.$error,
                    disable: !_vm.manageLiveClasses
                  },
                  on: { input: _vm.$v.date_class.$touch },
                  model: {
                    value: _vm.date_class,
                    callback: function($$v) {
                      _vm.date_class = $$v
                    },
                    expression: "date_class"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-6 col-sm-6" },
          [
            _c("q-input", {
              ref: "workload",
              attrs: {
                type: "number",
                "float-label": _vm.$t("workload_in_hours"),
                error: _vm.$v.workload.$error,
                disable: !_vm.manageLiveClasses
              },
              on: { input: _vm.$v.workload.$touch },
              model: {
                value: _vm.workload,
                callback: function($$v) {
                  _vm.workload = $$v
                },
                expression: "workload"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-11 col-sm-11" },
          [
            _c("q-select", {
              ref: "is_public",
              attrs: {
                options: _vm.is_public_options,
                "float-label": _vm.$t("live_class_type"),
                error: _vm.$v.is_public.$error,
                disable: !_vm.manageLiveClasses
              },
              on: { input: _vm.$v.is_public.$touch },
              model: {
                value: _vm.is_public,
                callback: function($$v) {
                  _vm.is_public = $$v
                },
                expression: "is_public"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "col-xs-1 col-sm-1",
            staticStyle: { padding: "10px 2px" }
          },
          [
            _c(
              "q-icon",
              {
                staticClass: "q-mr-sm q-pt-md",
                attrs: {
                  name: "fal fa-question-circle",
                  size: "1.5rem",
                  color: "grey"
                }
              },
              [
                _c(
                  "q-tooltip",
                  {
                    staticClass: "custom-tooltip",
                    attrs: { anchor: "top left", self: "bottom right" }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.getClassTypeTooltip(_vm.is_public)) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              [
                _c("q-input", {
                  ref: "qty_limit_participants",
                  attrs: {
                    type: "number",
                    filled: "",
                    "float-label": _vm.$t("qty_participants_info"),
                    error: _vm.$v.qty_limit_participants.$error,
                    disable: !_vm.manageLiveClasses
                  },
                  on: { input: _vm.$v.qty_limit_participants.$touch },
                  model: {
                    value: _vm.qty_limit_participants,
                    callback: function($$v) {
                      _vm.qty_limit_participants = _vm._n($$v)
                    },
                    expression: "qty_limit_participants"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              attrs: {
                options: _vm.optionTags,
                "float-label": _vm.$t("tags"),
                multiple: "",
                chips: "",
                filter: "",
                "autofocus-filter": "",
                disable: !_vm.manageLiveClasses
              },
              model: {
                value: _vm.tag,
                callback: function($$v) {
                  _vm.tag = $$v
                },
                expression: "tag"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
          _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v(_vm._s(_vm.$t("image")))
                ]),
                _c("uploader", {
                  attrs: {
                    content_type: "images",
                    multiple: false,
                    cropper: true,
                    aspect_ratio: 52 / 29,
                    aspect_ratio_string: "52/29",
                    disable: !_vm.manageLiveClasses
                  },
                  on: { fileUploaded: _vm.imageUploaded }
                }),
                _vm.image_url
                  ? _c(
                      "p",
                      { staticClass: "q-mt-md file-url" },
                      [
                        _c("q-icon", {
                          attrs: { name: "fal fa-check", color: "positive" }
                        }),
                        _c(
                          "a",
                          { attrs: { href: _vm.image_url, target: "_blank" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$truncateLink(_vm.image_url))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
              _c(
                "p",
                { staticClass: "caption" },
                [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(_vm.$t("alt_image")) +
                      "\n\t\t\t\t\t\t"
                  ),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-ml-sm q-pb-sm",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("alt_image_information_helper")) +
                              "\n\t\t\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between" },
                [
                  _vm._l(_vm.languages, function(lang) {
                    return [
                      lang.code === "pt-br"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_br",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_br.$error
                                },
                                on: { input: _vm.$v.title.$touch },
                                model: {
                                  value: _vm.language_br,
                                  callback: function($$v) {
                                    _vm.language_br = $$v
                                  },
                                  expression: "language_br"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "en-us"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_us",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_us.$error
                                },
                                on: { input: _vm.$v.title.$touch },
                                model: {
                                  value: _vm.language_us,
                                  callback: function($$v) {
                                    _vm.language_us = $$v
                                  },
                                  expression: "language_us"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "es-es"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_es",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_es.$error
                                },
                                on: { input: _vm.$v.title.$touch },
                                model: {
                                  value: _vm.language_es,
                                  callback: function($$v) {
                                    _vm.language_es = $$v
                                  },
                                  expression: "language_es"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      lang.code === "fr-fr"
                        ? _c(
                            "q-field",
                            { key: lang.id, attrs: { count: 170 } },
                            [
                              _c("q-input", {
                                ref: "language_fr",
                                refInFor: true,
                                attrs: {
                                  "float-label": _vm.$t("" + lang.name),
                                  error: _vm.$v.language_fr.$error
                                },
                                on: { input: _vm.$v.title.$touch },
                                model: {
                                  value: _vm.language_fr,
                                  callback: function($$v) {
                                    _vm.language_fr = $$v
                                  },
                                  expression: "language_fr"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c(
              "q-field",
              { attrs: { helper: "" + _vm.$t("date_to_unpublish") } },
              [
                _c("q-datetime", {
                  ref: "unpublish_date",
                  attrs: {
                    type: "date",
                    "float-label": _vm.$t("unpublish_date"),
                    format: "DD/MM/YYYY",
                    clearable: "",
                    disable: !_vm.manageLiveClasses
                  },
                  model: {
                    value: _vm.unpublish_date,
                    callback: function($$v) {
                      _vm.unpublish_date = $$v
                    },
                    expression: "unpublish_date"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 q-mb-md",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: {
                        disable: !_vm.manageLiveClasses,
                        val: true,
                        label: _vm.$t("select_all_areas")
                      },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        label: "",
                        filters: _vm.area,
                        options: _vm.areas,
                        error: _vm.$v.area.$error,
                        input: _vm.$v.area.$touch,
                        disable: !_vm.manageLiveClasses
                      },
                      on: {
                        on_value: function($event) {
                          _vm.area = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { ref: "profile", staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("profiles")))
                    ]),
                    _c(
                      "div",
                      { staticClass: "row gutter-sm" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-12" },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                val: true,
                                label: _vm.$t("all"),
                                disable: !_vm.manageLiveClasses
                              },
                              on: {
                                input: function($event) {
                                  return _vm.checkAll()
                                }
                              },
                              model: {
                                value: _vm.all_profiles,
                                callback: function($$v) {
                                  _vm.all_profiles = $$v
                                },
                                expression: "all_profiles"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(_vm.profiles, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "col-xs-12 col-sm-4",
                              class: _vm.getErrorClass(_vm.$v.profile.$error)
                            },
                            [
                              _c("q-checkbox", {
                                attrs: {
                                  "keep-color": "",
                                  val: item.value,
                                  label: item.label,
                                  color: _vm.getErrorColor(
                                    _vm.$v.profile.$error
                                  ),
                                  disable: !_vm.manageLiveClasses
                                },
                                on: { input: _vm.$v.profile.$touch },
                                model: {
                                  value: _vm.profile,
                                  callback: function($$v) {
                                    _vm.profile = $$v
                                  },
                                  expression: "profile"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                )
              ]),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("q-select", {
                      ref: "user_groups",
                      attrs: {
                        options: _vm.user_groups,
                        "float-label": _vm.$t("groups"),
                        error: _vm.$v.user_group.$error,
                        multiple: "",
                        chips: "",
                        disable: !_vm.manageLiveClasses
                      },
                      on: { input: _vm.$v.user_group.$touch },
                      model: {
                        value: _vm.user_group,
                        callback: function($$v) {
                          _vm.user_group = $$v
                        },
                        expression: "user_group"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm.id_live_class != 0
                ? _c("div", { staticClass: "row gutter-sm q-my-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-11" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("link"),
                            disable: true
                          },
                          model: {
                            value: _vm.url_live_class_portal,
                            callback: function($$v) {
                              _vm.url_live_class_portal = $$v
                            },
                            expression: "url_live_class_portal"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "full-width",
                            attrs: {
                              dense: "",
                              color: "primary",
                              icon: "fal fa-copy"
                            },
                            on: {
                              click: function($event) {
                                return _vm.copyLink()
                              }
                            }
                          },
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.$t("copy_link")) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 q-mt-xs" },
        [
          _c(
            "q-chips-input",
            {
              ref: "owners_list",
              attrs: {
                error: _vm.$v.owners.$error,
                "float-label": _vm.$t("owners"),
                disable: !_vm.manageLiveClasses
              },
              on: { input: _vm.$v.owners.$touch, remove: _vm.removeOwner },
              model: {
                value: _vm.owners_list,
                callback: function($$v) {
                  _vm.owners_list = $$v
                },
                expression: "owners_list"
              }
            },
            [
              _c("q-autocomplete", {
                attrs: {
                  "min-characters": 3,
                  "value-field": function(v) {
                    return v.full_name + " - " + v.email
                  }
                },
                on: { search: _vm.searchOwner, selected: _vm.selectOwner }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("p", { staticClass: "caption" }, [
              _vm._v(_vm._s(_vm.$t("status")))
            ]),
            _c("q-btn-toggle", {
              attrs: {
                "toggle-color": _vm.getColorStatus,
                options: _vm.statuses,
                disable: !_vm.manageLiveClasses
              },
              model: {
                value: _vm.status,
                callback: function($$v) {
                  _vm.status = $$v
                },
                expression: "status"
              }
            }),
            _c(
              "q-icon",
              {
                staticClass: " q-ml-md",
                attrs: {
                  name: "fal fa-question-circle",
                  size: "1.5rem",
                  color: "grey"
                }
              },
              [
                _c(
                  "q-tooltip",
                  {
                    staticClass: "custom-tooltip",
                    attrs: { anchor: "top left", self: "bottom left" }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("status_term")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_live_classes" })
                }
              }
            })
          ],
          1
        ),
        _vm.showDuplicateButton
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "info",
                    label: _vm.$t("duplicate_live_class"),
                    icon: "far fa-copy"
                  },
                  on: {
                    click: function($event) {
                      _vm.show_confirm_duplicate = true
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save",
                disable: !_vm.manageLiveClasses
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.duplicateLiveClass },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.show_confirm_duplicate = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "positive", label: _vm.$t("confirm") },
                    on: {
                      click: function($event) {
                        return _vm.duplicateLiveClass()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_confirm_duplicate,
            callback: function($$v) {
              _vm.show_confirm_duplicate = $$v
            },
            expression: "show_confirm_duplicate"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("duplicate_live_class")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              _vm._s(
                _vm.$t("confirm_duplicate_the_live_class_and_all_its_contents")
              )
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }